module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/Costada-Caparica-1f5b13b8a20da3dfdd3bc5498a13fb3a.jpg";